import { EmptyBetslipIcon } from 'assets/icons';
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'shared/components/form/button';
import { APP_URL } from 'shared/constants/common';
import { usePromoConditionsStateTypes } from '../../../PromoConditions';
import './styles.scss';
type EmptyBetType = {
	promoConditionsState: usePromoConditionsStateTypes;
};
const ELEMENT_HEIGHT = '100%';
const EmptyBet = (props: EmptyBetType) => {
	const { t } = useTranslation();
	const [height, setHeight] = useState<number | string>(ELEMENT_HEIGHT);
	useEffect(() => {
		const height = `calc(${ELEMENT_HEIGHT} - ${props.promoConditionsState.promoAccordionWrapperHeight ?? 0}px)`;

		setHeight(height);
	}, [props.promoConditionsState.promoAccordionWrapperHeight]);
	return (
		<div style={{ height }} className="betslipEmpty ">
			<div className={cn('betslipEmpty__wrapper transition-all duration-300 ease')}>
				<EmptyBetslipIcon />
				<div className="betslipEmpty__title">{t('betSlipMessage')}</div>
				<Button link={APP_URL.todaysOffer} btnType="primary" cyTestRef="todays-offer">
					{t('todayOffer')}
				</Button>
			</div>
		</div>
	);
};

export default EmptyBet;
